import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Bingo.css';
import Images from '../../constants';

const DB_URL = process.env.REACT_APP_DB_URL || process.env.API_URL || "http://localhost:10000";

// Estrutura estática do Grid de Bingo (75 números)
// 7 linhas com 10 colunas normais + 1 linha final de 5 colunas mescladas (colSpan=2)
const BINGO_GRID = [];
for (let r = 0; r < 7; r++) {
    BINGO_GRID.push([
        { number: 2 * r + 1 },
        { number: 2 * r + 2 },
        { number: 16 + 2 * r },
        { number: 17 + 2 * r },
        { number: 31 + 2 * r },
        { number: 32 + 2 * r },
        { number: 46 + 2 * r },
        { number: 47 + 2 * r },
        { number: 61 + 2 * r },
        { number: 62 + 2 * r }
    ]);
}
BINGO_GRID.push([
    { number: 15, colSpan: 2 },
    { number: 30, colSpan: 2 },
    { number: 45, colSpan: 2 },
    { number: 60, colSpan: 2 },
    { number: 75, colSpan: 2 }
]);

function Bingo() {
    const [numbers, setNumbers] = useState([]);
    const [setRoundId] = useState('');
    const [rodada, setRodada] = useState([]);

    const queryParameters = new URLSearchParams(window.location.search);
    const round_id = queryParameters.get("id");

    useEffect(() => {
        document.body.classList.add('bingo-body');

        if (round_id) {
            // Se um ID específico foi passado na URL, carrega aquela rodada específica
            axios.get(`${DB_URL}/rounds/${round_id}`)
                .then(response => {
                    if (response.data && response.data.numbers) {
                        setNumbers(response.data.numbers);
                        setRodada(response.data.id);
                        setRoundId(response.data.id);
                    }
                })
                .catch(err => console.error("Erro ao carregar rodada específica:", err));
        }

        // Conecta ao fluxo de eventos SSE do servidor
        const eventSource = new EventSource(`${DB_URL}/rounds/events`);

        eventSource.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                if (data && data.id) {
                    // Se estivermos monitorando um ID específico na URL,
                    // só atualiza se for a rodada correspondente.
                    if (!round_id || data.id === round_id) {
                        setNumbers(data.numbers || []);
                        setRodada(data.id);
                        setRoundId(data.id);
                    }
                } else if (data && data.status === 'not_found') {
                    if (!round_id) {
                        setNumbers([]);
                        setRodada('');
                        setRoundId('');
                    }
                }
            } catch (err) {
                console.error("Erro ao processar dados SSE:", err);
            }
        };

        eventSource.onerror = (err) => {
            console.error("Erro de conexão com o SSE:", err);
        };

        return () => {
            document.body.classList.remove('bingo-body');
            eventSource.close();
        };
    }, [round_id]);

    return (
        <div className="container">
            <div className='container-table'>
                <table id="bingo_tb" className='rTable'>
                    <thead>
                        <tr>
                            <th colSpan="2" className="thb">B</th>
                            <th colSpan="2" className="thi">I</th>
                            <th colSpan="2" className="thn">N</th>
                            <th colSpan="2" className="thg">G</th>
                            <th colSpan="2" className="tho">O</th>
                        </tr>
                    </thead>
                    <tbody>
                        {BINGO_GRID.map((rowData, rowIndex) => (
                            <tr key={rowIndex}>
                                {rowData.map((cell, colIndex) => {
                                    const isDrawn = numbers.some(num => Number(num) === cell.number);
                                    return (
                                        <td key={colIndex} colSpan={cell.colSpan || 1}>
                                            <div className={`circle ${isDrawn ? 'circle--active' : 'circle--inactive'}`}>
                                                {isDrawn ? (
                                                    <img
                                                        className="image"
                                                        src={Images[cell.number]}
                                                        alt={`Bolinha ${cell.number}`}
                                                    />
                                                ) : (
                                                    <span className="inactive-num-text">
                                                        {String(cell.number).padStart(2, '0')}
                                                    </span>
                                                )}
                                            </div>
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className='side-content'>
                <div className='side-content-header'></div>
                <div className='side-content-info'>
                    <span>RODADA: {rodada}</span>
                </div>
                <div className='last_ball_container'>
                    {numbers[numbers.length - 1] && (
                        <div className='last_ball' key={numbers[numbers.length - 1]}>
                            <img className="image_last_ball" src={Images[numbers[numbers.length - 1]]} alt="Ultimo número sorteado" />
                        </div>
                    )}
                </div>
                <div className='last_ball_container'>
                    {numbers[numbers.length - 2] && (
                        <div className="ballsContainer">
                            <fieldset>
                                <legend>5 BOLAS ANTERIORES</legend>
                                <div className="balls-row">
                                    {[2, 3, 4, 5, 6].map(offset => {
                                        const numVal = numbers[numbers.length - offset];
                                        return numVal && (
                                            <div key={numVal} className="balls">
                                                <img className="image_last_balls" src={Images[numVal]} alt="Numero sorteado" />
                                            </div>
                                        );
                                    })}
                                </div>
                            </fieldset>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Bingo;
